module.exports = __webpack_public_path__ + "static/media/17-1.5fdfc4c1.mp3";